import React, { useState, useEffect } from "react";
import { Link } from "../utils/localizedNav";
import { useTranslation } from "react-i18next";
import { API_URL, authFetch } from "../api";
import useIsMobile from "../hooks/useIsMobile";

export default function CountryNudgeBanner() {
  const { t } = useTranslation();
  const isMobile = useIsMobile();
  const userId = localStorage.getItem("userId");
  const dismissKey = userId ? `countryNudgeDismissed_${userId}` : null;

  const [show, setShow] = useState(false);

  useEffect(() => {
    if (!userId) return;
    if (localStorage.getItem(dismissKey)) return;

    authFetch(`${API_URL}/api/users/${userId}`)
      .then(r => r.json())
      .then(data => {
        if (!data?.country) setShow(true);
      })
      .catch(() => {});
  }, [userId, dismissKey]);

  const dismiss = () => {
    if (dismissKey) localStorage.setItem(dismissKey, "1");
    setShow(false);
  };

  if (!show) return null;

  return (
    <div style={{
      maxWidth: 760,
      margin: isMobile ? "8px 12px 0" : "12px auto 0",
      background: "linear-gradient(135deg, #fffbea, #fff3cc)",
      border: "1.5px solid #f0c030",
      borderRadius: 16,
      padding: isMobile ? "12px 14px" : "13px 20px",
      display: "flex", alignItems: "center",
      justifyContent: "space-between", flexWrap: "wrap", gap: 10,
      boxShadow: "0 3px 16px rgba(240,192,48,0.20)",
      animation: "nudgeSlideIn 0.3s ease-out",
    }}>
      <div style={{ display: "flex", alignItems: "center", gap: 10, flex: 1, minWidth: 0 }}>
        <span style={{ fontSize: 22, flexShrink: 0 }}>🌍</span>
        <div>
          <div style={{ fontWeight: 800, fontSize: isMobile ? 13 : 14, color: "#6a4200", lineHeight: 1.3 }}>
            {t("nudge.country.title")}
          </div>
          <div style={{ fontSize: isMobile ? 11 : 12, color: "#a07030", marginTop: 2 }}>
            {t("nudge.country.desc")}
          </div>
        </div>
      </div>
      <div style={{ display: "flex", alignItems: "center", gap: 8, flexShrink: 0 }}>
        <Link
          to="/profile"
          onClick={dismiss}
          style={{
            background: "linear-gradient(135deg, #f0c030, #d4a800)",
            color: "#3a1e00", borderRadius: 999,
            padding: isMobile ? "7px 14px" : "8px 18px",
            fontWeight: 800, fontSize: isMobile ? 12 : 13,
            textDecoration: "none",
            boxShadow: "0 2px 8px rgba(240,192,48,0.35)",
            whiteSpace: "nowrap",
          }}
        >
          {t("nudge.country.cta")}
        </Link>
        <button
          type="button"
          onClick={dismiss}
          aria-label="Schließen"
          style={{
            border: "none", background: "none", cursor: "pointer",
            color: "#c8a040", fontSize: 18, lineHeight: 1, padding: "2px 4px",
          }}
        >✕</button>
      </div>
      <style>{`@keyframes nudgeSlideIn { from { opacity:0; transform:translateY(-8px); } to { opacity:1; transform:translateY(0); } }`}</style>
    </div>
  );
}
